import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_10446_27398)\"><rect width=\"24\" height=\"24\" rx=\"12\" fill=\"#9BC9D0\"></rect><circle cx=\"11.9996\" cy=\"10.1429\" r=\"4.28571\" fill=\"#3C646A\"></circle><circle cx=\"12\" cy=\"26.5\" r=\"11\" fill=\"#3C646A\"></circle></g><defs><clipPath id=\"clip0_10446_27398\"><rect width=\"24\" height=\"24\" rx=\"12\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }